import React from 'react';
import './Bottombar.css'
import styles from './Bottombar.module.css'
import { NavLink } from 'react-router-dom';

import appleLogo from '../../assets/ic_apple.png';
import facebookLogo from '../../assets/ic_facebook.png';
import instagramLogo from '../../assets/ic_instagram.png';
import googlePlayLogo from '../../assets/ic_google_play.png';


const bottombar = ({onGetStartedClick}) => {
    return (
        <div style={{backgroundColor: '#309cff'}}>
            <div className={styles.getStartedContainer}>
                <p className={styles.getStartedDesc}>
                    Learn Hebrew with Shepha
                </p>
                <p className={styles.getStartedButton} onClick={onGetStartedClick}>
                    GET STARTED
                </p>
            </div>
            <div className="bottom-bar">
                <div className="left-layout">
                    <a target='_blank' href="https://apps.apple.com/il/app/shepha/id1485115845"><img src={appleLogo} alt="Apple logo" /></a>
                    <a target='_blank' href="https://play.google.com/store/apps/details?id=com.vinet.shepha"><img src={googlePlayLogo} alt="Google play logo" /></a>
                    <NavLink to="/" exact style={{ color: "inherit" }} activeStyle={{ color: "rgba(255,255,255,0.6)" }}><p>Home</p></NavLink>
                    <NavLink to="/privacy" style={{ color: "inherit" }} activeStyle={{ color: "rgba(255,255,255,0.6)" }}><p>Privacy policy</p></NavLink>
                </div>
                <div className="right-layout">
                    <p>Contact us at <a style={{ color: '#440F57' }} href="mailto:Shepha.app@gmail.com">Shepha.app@gmail.com</a></p>
                    <a href="/" ><img src={instagramLogo} alt="Instagram logo" /></a>
                    <a href="/" ><img src={facebookLogo} alt="Facebook logo" /></a>
                </div>
            </div>
        </div>
    );
}

export default bottombar;